import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import Modal from '../../components/Modal'
import VideoForm from '../../components/VideoForm'
import { useDeleteVideoMutation, useGetVideosQuery } from '../../features/video/videoApi'
import SkeletonLoader from '../../components/ui/SkeletonLoader'
import swal from 'sweetalert'
import { useDispatch, useSelector } from 'react-redux'
import { addVideoModal, updateVideoModal } from '../../features/video/videoSlice'


export default function Videos() {
    const dispatch = useDispatch()
    const { mode, videoId } = useSelector(state => state.video.modal) || {}
    const { isSuccess, data: videos, isLoading } = useGetVideosQuery()
    const [deleteVideo, { isSuccess: isSuccessDeleteVideo }] = useDeleteVideoMutation()


    useEffect(() => {
        if (isSuccessDeleteVideo) {
            swal("Successful", "Video delete successful", "success");
        }
    }, [isSuccessDeleteVideo,])


    function confirmDelete(videoId) {
        swal({
            title: "Are you sure?",
            text: "You will not be able to recover this video!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    if (videoId) {
                        deleteVideo(videoId)
                    }

                } else {
                    swal("Your video is safe!");
                }
            });
    }

    let content;

    if (isLoading) {
        content = <SkeletonLoader />
    } else if (isSuccess && videos?.length > 0) {
        content = videos.map(video => <tr key={video.id}>
            <td className="table-td">{video.title.slice(0, 60)}...</td>
            <td className="table-td">{video.description.slice(0, 100)}...</td>
            <td className="table-td flex gap-x-2">
                <button onClick={() => confirmDelete(video.id)}>
                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                        className="w-6 h-6 hover:text-red-500 cursor-pointer transition-all">
                        <path strokeLinecap="round" strokeLinejoin="round"
                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                    </svg>
                </button>
                <button onClick={() => dispatch(updateVideoModal({ type: "open" ,videoId: video.id }))}>
                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                        className="w-6 h-6 hover:text-blue-500 cursor-pointer transition-all">
                        <path strokeLinecap="round" strokeLinejoin="round"
                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                    </svg>
                </button>
            </td>
        </tr>)
    } else if (isSuccess && videos.length === 0) {
        content = <h2 className='text-2xl'>No video here</h2>
    }

    return (
        <Layout>
            <section className="py-6 bg-primary">
                {mode === "add" && <Modal>
                    <VideoForm mode="add" />
                </Modal>}

                {mode === "edit" && videoId && <Modal >
                    <VideoForm mode="edit" />
                </Modal>}

                <div className="mx-auto max-w-full px-5 lg:px-20">
                    <div className="px-3 py-20 bg-opacity-10">
                        <div className="w-full flex">
                            <button onClick={() => dispatch(addVideoModal({type: "open"}))} className="btn text-white bg-blue-600 hover:bg-blue-700 ml-auto">Add Video</button>
                        </div>
                        <div className="overflow-x-auto mt-4">
                            <table className="divide-y-1 text-base divide-gray-600 w-full">
                                <thead>
                                    <tr>
                                        <th className="table-th">Video Title</th>
                                        <th className="table-th">Description</th>
                                        <th className="table-th">Action</th>
                                    </tr>
                                </thead>

                                <tbody className="divide-y divide-slate-600/50">
                                    {content}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
